
import { baseUrl, getTokenHeaders, getCredentialHeaders, getCredentialHeadersJson } from '../utils/headersConfig';
import * as querystring from 'querystring';
import MagentaRequest from '../requests/magentaRequest';
import TokenServices from './tokenServices';
import { browserUtils } from '@/leapsight-styleguide'


export class MagentaRestServices {

  /**
  * @description Sets up the needed data and prepare the request
  *
  * @returns response of the request
  */
  static async login(username: string, password: string) {
    const url = baseUrl+'/oauth/token'
    const browserIdentifier = localStorage.getItem('DEVICE_IDENTIFIER') ?? await browserUtils.generateId()
    localStorage.setItem('DEVICE_IDENTIFIER', browserIdentifier)
    const body = querystring.stringify({
      password: password,
      username: username,
      grant_type: 'password',
      client_device_id: browserIdentifier
    })
    const options = getCredentialHeaders();

    const response = await MagentaRequest.login(url, body, options)
    return response
  }

  static async logout(){

    const url = baseUrl+'/oauth/revoke'
    const body = `token=${TokenServices.getRefreshToken()}&token_type_hint=refresh_token`
    const options = getCredentialHeaders();

    const response = await MagentaRequest.logout(url, body, options)
    return response
  }

  static async refreshToken(){    
    const url = baseUrl+'/oauth/token'
    const body = `refresh_token=${TokenServices.getRefreshToken()}&grant_type=refresh_token`
    const options = getCredentialHeaders();

    const response = await MagentaRequest.refreshToken(url, body, options)
    return response;
  }
  
  getUserAccount(){
    const url = baseUrl+'users/me'
  }

  static async setPassword(data) {
    const url = baseUrl+'/v1.5/services/users/set_password'
    
    const body = {
      username: data.username,
      user_id: data.user_id,
      password_code: data.password_code,
      password: data.password
    }

    const options = getCredentialHeadersJson();

    const response = await MagentaRequest.setPassword(url, body, options)
    return response
  }

  static async changePassword(username: string) {
    const url = baseUrl + '/v1.5/services/users/request_change_password'

    const body = {
      username: username
    }

    const options = getCredentialHeadersJson();

    const response = await MagentaRequest.changePassword(url, body, options)
    return response
  }

  static async requestWelcomeMail(data) {
    const url = baseUrl + '/v1.5/services/users/request_welcome_email'

    const body = {
      username: data.username,
      user_id: data.user_id
    }

    const options = getCredentialHeadersJson();

    const response = await MagentaRequest.requestWelcomeMail(url, body, options)
    return response
  }


}

export default MagentaRestServices

